import React, { useContext } from 'react';
import OfferPageContainerComponent from './OfferPageContainer/OfferPageContainer.container';
import { I18nContext } from 'utils/I18n/context';

const OfferPage = () => {
    const { t } = useContext(I18nContext);
    const staticNames = t?.offersPage?.offer || { title: 'Offer' };

    return (
        <React.Fragment>
            <div className="page-heading">
                <div className="page-heading__inner">
                    <h2>{staticNames.title}</h2>
                </div>
            </div>

            <section className="wrapper-content offers">
                <OfferPageContainerComponent />
            </section>
        </React.Fragment>
    );
};

export default OfferPage;
